
export default {
  props: ["AMap", "building"],
  data() {
    return {
      isOpen: false,
      hanpai: null, // 航拍数据
      satellite: null,
      active: 0,
      isHanPai: false,
      isJieJing: false,
      mapEvents: ["click", "touchend"],
    };
  },
  mounted() {},
  methods: {
    // 生成VR全景
    generateVRView() {
      if (!this.hanpai) {
        this.hanpai = require("@/data/footmarker.json");
        let geojson = {
          type: "FeatureCollection",
          features: this.hanpai.data.map(function (item) {
            return {
              type: "Feature",
              properties: item,
              geometry: {
                type: "Point",
                coordinates: item.point.split(",").map(Number), // 转换为 [longitude, latitude]
              },
            };
          }),
        };

        this.building.addSource("VRView", {
          type: "geojson",
          data: geojson,
          cluster: true, // 开启聚合
          clusterMaxZoom: 14, // 最大聚合层级
          clusterRadius: 50, // 聚合半径
        });

        this.building.addLayer({
          id: "clusters",
          type: "circle",
          source: "VRView",
          filter: ["has", "point_count"],
          paint: {
            "circle-color": [
              "step",
              ["get", "point_count"],
              "#51bbd6",
              100,
              "#f1f075",
              750,
              "#f28cb1",
            ],
            "circle-radius": [
              "step",
              ["get", "point_count"],
              20,
              100,
              30,
              750,
              40,
            ],
          },
        });

        this.building.addLayer({
          id: "cluster-count",
          type: "symbol",
          source: "VRView",
          filter: ["has", "point_count"],
          layout: {
            "text-field": "{point_count_abbreviated}",
            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
            "text-size": 12,
            // visibility: "visible",
          },
        });

        this.building.addLayer({
          id: "unclustered-point",
          type: "circle",
          source: "VRView",
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": "#11b4da",
            "circle-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              12,
              4,
              22,
              50,
            ],
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff",
          },
        });

        this.building.addLayer({
          id: "unclustered-point-hover",
          type: "circle",
          source: "VRView",
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": "#11b4da",
            "circle-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              12,
              6,
              22,
              60,
            ],
            "circle-stroke-width": 2,
            "circle-stroke-color": "#fff",
          },
          layout: {
            visibility: "none",
          },
        });

        this.building.addLayer({
          id: "unclustered-point-label",
          type: "symbol",
          source: "VRView",
          layout: {
            "text-field": ["get", "filename"],
            "text-variable-anchor": ["top", "bottom", "left", "right"],
            "text-justify": "auto",
            "text-size": 13,
          },
        });

        this.building.on("mousemove", "unclustered-point", (e) => {
          this.building.getCanvas().style.cursor = "pointer";
          this.building.setLayoutProperty(
            "unclustered-point-hover",
            "visibility",
            "visible"
          );
          // 输出对应的json数据
          var features = this.building.queryRenderedFeatures(e.point, {
            layers: ["unclustered-point"],
          });
          // if (features.length > 0) {
          //   console.log(features[0].properties);
          // }
        });

        this.building.on("mouseleave", "unclustered-point", () => {
          this.building.getCanvas().style.cursor =
            this.switchPoint($(".mapboxgl-ctrl-group .active").attr("title")) ||
            "";
          this.building.setLayoutProperty(
            "unclustered-point-hover",
            "visibility",
            "none"
          );
        });

        this.mapEvents.forEach((eve) => {
          this.building.on(eve, "clusters", (e) => {
            this.building.getCanvas().style.cursor = "pointer";
            // 输出对应的json数据
            var features = this.building.queryRenderedFeatures(e.point, {
              layers: ["clusters"],
            });
            var clusterId = features[0].properties.cluster_id;
            this.building
              .getSource("VRView")
              .getClusterExpansionZoom(clusterId, (err, zoom) => {
                if (err) return;
                this.building.easeTo({
                  center: features[0].geometry.coordinates,
                  zoom: zoom,
                });
              });
          });
        });

        this.building.on("click", "unclustered-point", (e) => {
          this.building.getCanvas().style.cursor = "pointer";
          // 输出对应的json数据
          var features = this.building.queryRenderedFeatures(e.point, {
            layers: ["unclustered-point"],
          });
          if (features.length > 0) {
            this.$emit("doVRURL", {
              prop: features[0].properties,
              lnglat: e.lngLat,
            });
          }
        });
      } else {
        this.hideVr();
      }
    },
    hideVr() {
      if (this.isHanPai) {
        this.building.setLayoutProperty("clusters", "visibility", "visible");
        this.building.setLayoutProperty(
          "cluster-count",
          "visibility",
          "visible"
        );
        this.building.setLayoutProperty(
          "unclustered-point",
          "visibility",
          "visible"
        );
        this.building.setLayoutProperty(
          "unclustered-point-label",
          "visibility",
          "visible"
        );
      } else {
        if (this.building.getLayer("clusters")) {
          this.building.setLayoutProperty("clusters", "visibility", "none");
          this.building.setLayoutProperty(
            "cluster-count",
            "visibility",
            "none"
          );
          this.building.setLayoutProperty(
            "unclustered-point-hover",
            "visibility",
            "none"
          );
          this.building.setLayoutProperty(
            "unclustered-point",
            "visibility",
            "none"
          );
          this.building.setLayoutProperty(
            "unclustered-point-label",
            "visibility",
            "none"
          );
          if (this.building.getSource("sector-source")) {
            this.building.removeLayer("sector-layer");
            this.building.removeSource("sector-source");
          }
        }

        this.$emit("hideVR");
      }
    },
    generateJieJingView() {
      if (this.isJieJing) {
        this.$emit("openJieJingView");
      } else {
        this.$emit("closeJieJingView");
      }
    },
    switchPoint(val) {
      switch (val) {
        case "测面 （拖拽后双击地图标记）":
          return "crosshair";
        case "测距 （拖拽后双击地图标记）":
          return "crosshair";
        case "标记 （鼠标左键）":
          return "";
        default:
          return "";
      }
    },
    // 开关
    changeState(isOpen) {
      this.isOpen = isOpen;
    },
    async changeBaseMap(val) {
      if (val == 0) {
        $("#map").show();
        if (this.satellite) {
          this.satellite.hide();
        }
        this.building.setLayoutProperty("gd-vector", "visibility", "none");
        this.building.setLayoutProperty(
          "gd-vector-yingxiang",
          "visibility",
          "none"
        );
        this.AMap.setMapStyle(`amap://styles/normal`);
        this.active = val;
        this.isJieJing = false;
        this.generateJieJingView();
        this.$emit("baseMapChanged", false);
      } else if (val == 1) {
        $("#map").hide();
        this.AMap.setPitch(0);
        this.building.setPitch(0);
        this.building.setLayoutProperty("gd-vector", "visibility", "none");
        this.building.setLayoutProperty(
          "gd-vector-yingxiang",
          "visibility",
          "visible"
        );
        this.active = val;
        this.isJieJing = false;
        this.generateJieJingView();
        this.$emit("baseMapChanged", true);
        // $('#map').show()
        // this.building.setLayoutProperty('gd-vector', 'visibility', 'none');
        // if (this.satellite) {
        //   this.satellite.show()
        //   this.AMap.setMapStyle(`amap://styles/light`)
        //   this.active = val
        // } else {
        //   this.satellite = new AMap.TileLayer.Satellite()
        //   this.satellite.setMap(this.AMap)
        //   this.AMap.setMapStyle(`amap://styles/light`)
        //   this.active = val
        // }
      } else if (val == 2) {
        $("#map").hide();
        this.building.setLayoutProperty(
          "gd-vector-yingxiang",
          "visibility",
          "none"
        );
        this.building.setLayoutProperty("gd-vector", "visibility", "visible");
        this.active = val;
        this.isJieJing = false;
        this.generateJieJingView();
        this.$emit("baseMapChanged", true);
      } else if (val == 4) {
        // this.$toasted.show('暂未开放', {position: "top-center", duration: 500})
        this.isJieJing = !this.isJieJing;
        this.isHanPai = false;
        this.generateJieJingView();
        this.hideVr();
      } else {
        // this.$toasted.show('暂未开放', {position: "top-center", duration: 500})
        this.isHanPai = !this.isHanPai;
        this.isJieJing = false;
        this.generateJieJingView();
        this.generateVRView();
      }
    },
  },
};
